import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { projectsApi } from "../api/projects";
import "../styles/pages.css";

function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    projectsApi.getAll()
      .then((data) => setProjects(Array.isArray(data) ? data : []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Navbar />
      <main className="cdh-page cdh-page--reader">
        <div className="cdh-page-hdr">
          <div className="cdh-page-hdr__eyebrow">What We Built</div>
          <h1 className="cdh-page-hdr__title">Real tools. Real companies. Real results.</h1>
          <p className="cdh-page-hdr__sub">
            Production-grade automation tools built for mechanical and BIM engineering companies. Not demos.
          </p>
        </div>

        {loading && <div className="cdh-state">Loading projects…</div>}
        {error && <div className="cdh-state cdh-state--error">Failed to load: {error}</div>}

        {!loading && !error && (
          <div className="cdh-grid">
            {projects.map((p) => (
              <Link to={`/projects/${p.slug}`} key={p.slug} className="cdh-card">
                <div className="cdh-card__thumb">
                  {p.cover_image_url ? (
                    <img src={p.cover_image_url} alt={p.title} />
                  ) : (
                    <div className="cdh-card__thumb-placeholder">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <rect x="3" y="3" width="18" height="18" rx="2" />
                        <circle cx="8.5" cy="8.5" r="1.5" />
                        <path d="M21 15l-5-5L5 21" />
                      </svg>
                      Video / screenshot coming soon
                    </div>
                  )}
                </div>
                <div className="cdh-card__body">
                  <div className="cdh-card__title">{p.title}</div>
                  <div className="cdh-card__excerpt">{p.description}</div>
                  <div className="cdh-card__tags">
                    {(typeof p.tags === "string" ? JSON.parse(p.tags) : p.tags).map((t) => (
                      <span key={t} className="cdh-card__tag">{t}</span>
                    ))}
                  </div>
                </div>
                <div className="cdh-card__footer">
                  <span style={{ color: "var(--muted)", fontSize: "12px" }}>
                    {(typeof p.tags === "string" ? JSON.parse(p.tags) : p.tags)[0]}
                  </span>
                  <span style={{ color: "var(--brand)", fontWeight: 500 }}>View Project →</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}

export default ProjectsPage;
